import link from './link'

export const fields = `
  _type,
  ${link.fragment('contactLink')},
  ${link.fragment('clientLoginLink')},
  about {
    title,
    links[]{${link.fields}},
    phoneNumber,
    email
  },
  location {
    title,
    timeZone,
    address,
    addressLink
  },
  services {
    title,
    links[]{${link.fields}}
  },
  expertise {
    title,
    links[]{${link.fields}}
  }
`

export const fragment = (name = 'navigation') => `${name}{${fields}}`

const exported = {
  fields,
  fragment,
}

export default exported
